module.exports = __webpack_public_path__ + "static/images/ui/ui-bg_flat_30_cccccc_40x100.png";